import React, { useState, useLayoutEffect,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./DilemaQuizResult.css";
import CommomBanner from "../CommomBanner/CommomBanner";
import DilemaResultBeforePayment from "../DilemaResultBeforePayment/DilemaResultBeforePayment";
import aa from "../../images/Guarded.svg";
import bb from "../../images/Mission.svg";
import cc from "../../images/Volatile.svg";
import dd from "../../images/Tactical.svg";
import Speedometer2 from "../Speedometer2/Speedometer2";
import Speedometer from "../SpeedometerChart/Speedometer";
import fire from "../../images/fire.svg";
import loadimg from "../../images/pp-logo.gif";
import { useParams } from "react-router-dom";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import DilemaCards from "../DilemaCards/DilemaCards";
import DilemaUniques from "../DilemaUniques/DilemaUniques";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SharePopup from "../ResultChart/SharePopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DilemaBarGraph from "../DilemaBarGraph/DilemaBarGraph";
import { toPng } from "html-to-image";

// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import bootstrap from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle';
// import { Tooltip } from 'bootstrap';
 
import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const CAPTURE_WIDTH = 1200;

const COL_WIDTHS = {
  "col-md-1": "8.333%",
  "col-md-2": "16.666%",
  "col-md-3": "25%",
  "col-md-4": "33.333%",
  "col-md-5": "41.666%",
  "col-md-6": "50%",
  "col-md-7": "58.333%",
  "col-md-8": "66.666%",
  "col-md-9": "75%",
  "col-md-10": "83.333%",
  "col-md-11": "91.666%",
  "col-md-12": "100%",
};

function imp(node, prop, value) {
  const cssProp = prop.replace(/([A-Z])/g, (m) => `-${m.toLowerCase()}`);
  node.style.setProperty(cssProp, value, "important");
}

function forceDesktopLayout(el) {
  const restore = [];

  const saveNode = (node) => {
    const saved = node.getAttribute("style") || "";
    restore.push(() => {
      if (saved) {
        node.setAttribute("style", saved);
      } else {
        node.removeAttribute("style");
      }
    });
  };

  saveNode(el);
  imp(el, "width", `${CAPTURE_WIDTH}px`);
  imp(el, "maxWidth", `${CAPTURE_WIDTH}px`);
  imp(el, "minWidth", `${CAPTURE_WIDTH}px`);
  imp(el, "overflow", "visible");
  imp(el, "boxSizing", "border-box");

  Object.entries(COL_WIDTHS).forEach(([cls, pct]) => {
    el.querySelectorAll(`.${cls}`).forEach((col) => {
      saveNode(col);
      imp(col, "width", pct);
      imp(col, "maxWidth", pct);
      imp(col, "minWidth", "0");
      imp(col, "flex", `0 0 ${pct}`);
      imp(col, "float", "none");
      imp(col, "boxSizing", "border-box");
      imp(col, "display", "block");
    });
  });

  el.querySelectorAll(
    ".row, .dilema-inner-box, .dilema-outer-box, .dilema-cardBox, .dilema-uniq-row",
  ).forEach((row) => {
    saveNode(row);
    imp(row, "display", "flex");
    imp(row, "flexWrap", "wrap");
    imp(row, "width", "100%");
    imp(row, "boxSizing", "border-box");
  });

  el.querySelectorAll(".dilema-quiz-row").forEach((row) => {
    saveNode(row);
    imp(row, "display", "flex");
    imp(row, "flexWrap", "wrap");
    imp(row, "width", "100%");
  });

  el.querySelectorAll(".dilema-quiz-card").forEach((card) => {
    saveNode(card);
    imp(card, "display", "flex");
    imp(card, "flexDirection", "column");
    imp(card, "flexWrap", "nowrap");
    imp(card, "width", "100%");
    imp(card, "minHeight", "220px");
    imp(card, "boxSizing", "border-box");
  });

  el.querySelectorAll(".diema-barchart-call, .barchart-container").forEach(
    (c) => {
      saveNode(c);
      imp(c, "width", "320px");
      imp(c, "maxWidth", "320px");
    },
  );

  el.querySelectorAll(".speedomte").forEach((s) => {
    saveNode(s);
    imp(s, "display", "flex");
    imp(s, "justifyContent", "center");
    imp(s, "alignItems", "center");
    imp(s, "width", "100%");
  });

  el.querySelectorAll(".page").forEach((p) => {
    saveNode(p);
    imp(p, "justifyContent", "center");
    imp(p, "alignItems", "center");
  });

  el.querySelectorAll(".speedmter-button").forEach((btn) => {
    saveNode(btn);
    imp(btn, "marginLeft", "auto");
    imp(btn, "marginRight", "auto");
  });

  el.querySelectorAll(".dile-uniq-res").forEach((d) => {
    saveNode(d);
    imp(d, "width", "100%");
  });

  return () => restore.forEach((fn) => fn());
}

async function waitForImages(el) {
  const imgs = Array.from(el.querySelectorAll("img"));
  await Promise.all(
    imgs.map((img) => {
      if (img.complete && img.naturalWidth > 0) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
        setTimeout(resolve, 3000);
      });
    }),
  );
}

async function canvasesToImages(el) {
  const restore = [];

  el.querySelectorAll(".diema-barchart-call, .barchart-container").forEach(
    (wrapper) => {
      if (typeof wrapper.__redrawAt === "function") wrapper.__redrawAt(320);
    },
  );

  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => requestAnimationFrame(r));

  for (const canvas of Array.from(el.querySelectorAll("canvas"))) {
    let dataUrl;
    try {
      dataUrl = canvas.toDataURL("image/png");
    } catch {
      continue;
    }

    const img = document.createElement("img");
    img.src = dataUrl;
    img.style.display = "block";
    img.style.width = canvas.offsetWidth + "px";
    img.style.height = canvas.offsetHeight + "px";

    canvas.parentNode.insertBefore(img, canvas);
    canvas.style.display = "none";
    restore.push(() => {
      canvas.style.display = "";
      img.remove();
    });
  }

  return () => restore.forEach((fn) => fn());
}

async function scrollIntoViewAndWait(el) {
  const prevScroll = window.scrollY;
  el.scrollIntoView({ block: "start", behavior: "instant" });
  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => setTimeout(r, 150));
  return () => window.scrollTo({ top: prevScroll, behavior: "instant" });
}

async function captureSection(ref, label) {
  if (!ref?.current) {
    console.warn(`captureSection: null ref [${label}]`);
    return null;
  }

  const el = ref.current;

  const restoreScroll = await scrollIntoViewAndWait(el);
  await waitForImages(el);
  const restoreLayout = forceDesktopLayout(el);
  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => setTimeout(r, 300));
  const restoreCanvases = await canvasesToImages(el);

  let blob = null;
  try {
    const dataUrl = await toPng(el, {
      quality: 1,
      backgroundColor: "#ffffff",
      pixelRatio: 2,
      width: el.scrollWidth,
      height: el.scrollHeight,
      style: {
        transform: "none",
        transformOrigin: "top left",
        overflow: "visible",
      },
      filter: (node) => node.tagName !== "LINK",
    });
    blob = await (await fetch(dataUrl)).blob();
  } catch (err) {
    console.error(`toPng failed [${label}]:`, err);
  }

  restoreCanvases();
  restoreLayout();
  restoreScroll();
  return blob;
}

function DilemaQuizResult({ admin, globaltest, userdetail, onLoginChange , paid}) {
  const { slug } = useParams();

  const [IsAdmin, setIsAdmin] = useState(admin);
  const [Ispaid, setIsPaid] = useState(paid);
  const [resultReady, setResultReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [Dilemma, setDilemma] = useState([]);
  const [DilemmaResult, setDilemmaResult] = useState([]);
  const [AnaysisData, setAnaysisData] = useState([]);
  const [OverallData, setOverallData] = useState(0);
  const [testlink, settestlink] = useState("");
  const [ArcheType, setArcheType] = useState([]);
  const [DilemmaTypes, setDilemmaTypes] = useState([]);
  const [HeatContent, setHeatContent] = useState([]);
  const [UserResult, setUserResult] = useState([]);
  const [DilemmaSlug, setDilemmaSlug] = useState("");
  const [DilemmaTop, setDilemmaTop] = useState([]);
  const [GraphData, setGraphData] = useState([]);
  const [EmailSuccess, setEmailSuccess] = useState(false);
  const [PdfLoading, setPdfLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const sectionCardsRef = useRef(null);
  const sectionSubCardsRef = useRef(null);
  const sectionQuizRef = useRef(null);
  const sectionRefs = useRef({});


const listRef = useRef(null);

useEffect(() => {
  if (!DilemmaTop?.length) return;

  // Small delay to ensure DOM is fully painted and Bootstrap is ready
  const init = setTimeout(() => {
    const elements = listRef.current?.querySelectorAll('[data-bs-toggle="tooltip"]') || [];
    if (!elements.length) return;

    elements.forEach(el => {
      // Dispose existing instance first to avoid duplicate/stale tooltips
      const existing = bootstrap.Tooltip.getInstance(el);
      if (existing) existing.dispose();

      new bootstrap.Tooltip(el, {
        container: 'body',
        trigger: 'hover focus'
      });
    });
  }, 100);

  return () => {
    clearTimeout(init);

    // Cleanup all tooltip instances on unmount
    const elements = listRef.current?.querySelectorAll('[data-bs-toggle="tooltip"]') || [];
    elements.forEach(el => {
      bootstrap.Tooltip.getInstance(el)?.dispose();
    });
  };

}, [DilemmaTop]);


  useEffect(() => {
    setIsAdmin(admin ?? false);
    setIsPaid(paid ?? false);
  }, [admin, paid]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    FetchResultData();
  }, []);

  useEffect(() => {
    if (
      Dilemma &&
      typeof Dilemma === "object" &&
      Object.keys(Dilemma).length > 0
    ) {
      setResultReady(true);
    }
  }, [Dilemma]);

  const FetchResultData = async () => {

    const url = Ispaid ? "admin-dilemma" : "dilemma-result";

    try {
      const res = await fetch(`${END_URL}/${url}/${slug}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          admin: IsAdmin ? true : false,
          paid: Ispaid ? true : false,
        }),

      });
      const data = await res.json();
      setDilemma(data.dilemma);
      setDilemmaResult(data?.dilemma_results);
      setAnaysisData(data?.analysis);
      setOverallData(data?.overall_percent);
      settestlink(data?.test_link);
      setDilemmaTypes(data?.dilemma_types);
      setArcheType(data?.arche_type);
      setUserResult(data?.user_result);
      setHeatContent(data?.heat_content);
      setDilemmaSlug(data?.dilemma_test_slug);
      setDilemmaTop(data?.dilemma_top);
      setGraphData(data?.graph_data);
    } catch (err) {
      console.error("FetchResultData:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const scrollToSection = (id) => {
    const el = sectionRefs.current[id];
    if (!el) return;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.pageYOffset - 130,
      behavior: "smooth",
    });
  };

  const showPastResults = (s) => navigate(`/dilemma-past-results/${s}`);
  const handleShare = () => setIsSharePopupOpen(true);

  const dilemma_slug = (Dilemma?.name || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+|-+$/g, "");

  const shareUrl = `${IMG_URL}/view-image-result/${Dilemma?.id}/${dilemma_slug}?v=${Dilemma?.version}`;
  const filename = Dilemma?.share_image?.split("/").pop() || "";
  const shareImg = Dilemma?.share_image || "";
  const shareTitle = Dilemma?.name || "Dilemma";
  const shareText = `${shareTitle} result!`;

  const handleEmailPdf = async () => {
    setPdfLoading(true);
    try {
      const blob1 = await captureSection(sectionCardsRef, "cards");
      const blob2 = await captureSection(sectionSubCardsRef, "sub-cards");
      const blob3 = await captureSection(sectionQuizRef, "quiz-outer");

      const formData = new FormData();
      if (blob1) formData.append("image_cards", blob1, "section_cards.png");
      if (blob2)
        formData.append("image_sub_cards", blob2, "section_sub_cards.png");
      if (blob3) formData.append("image_quiz", blob3, "section_quiz.png");
      formData.append("slug", DilemmaSlug);
      formData.append("test_slug", slug);

      const res = await fetch(`${END_URL}/upload-dilemma-result-image`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        setEmailSuccess(true);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("handleEmailPdf:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setPdfLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (isLoading || !resultReady) {
    return (
      <div className="loader-container">
        <img src={loadimg} alt="Loading..." className="loader-gif" />
      </div>
    );
  }










  const value = OverallData;

  const measuredText = HeatContent?.heat_measured_label || '';

  const formattedMeasuredText = measuredText.replace(
    '{value}',
    `<span>${value}</span>`
  );






  return (
    <>
      {PdfLoading && (
        <div className="loader-overlay">
          <img src={loadimg} alt="Loading..." className="loader-gif" />
        </div>
      )}

      <div className="test-main1 test-common-container dil-quiz">
        <div className="container-fluid">
          <CommomBanner
            banner={Dilemma?.full_banner_image}
            name={Dilemma?.name}
          />
        </div>

        <div className="container">
          <div className="row dilema-result-speed-append">
            <div className="col-md-12">
              <div className="dilema-cards-in-result" ref={sectionCardsRef}>
                <DilemaCards
                  DilemmaSlug={DilemmaSlug}
                  infoContent={HeatContent?.dilemma_arche_type_info}
                  testlink={testlink}
                  Dilemma={Dilemma}
                  ArcheType={ArcheType}
                  DilemmaTypes={DilemmaTypes}
                  UserResult={UserResult}
                  TierBreak={HeatContent?.traits_breakdown_text}
                  DilemmaShare={HeatContent?.dilemma_share_button}
                  
                />
                <div className="flex items-center space-x-2 dilemma-share-image mobile-share">
                  <button className="button freereul" onClick={handleShare}>
                    {HeatContent?.dilemma_share_button || "Share Result"}
                    <span>
                      <FontAwesomeIcon className="icc" icon={faArrowRight} />
                    </span>
                  </button>
                  {copied && (
                    <span className="ml-2 text-green-500 text-sm font-medium">
                      Link copied!
                    </span>
                  )}
                </div>
                {DilemmaTypes?.length > 0 && (
                  <div className="dile-uniq-res">
                    <DilemaUniques DilemmaTypes={DilemmaTypes} />
                  </div>
                )}
              </div>
            </div>
          </div>

          {DilemmaTop?.length > 0 && (
            <div className="row dilema-sub-cards" ref={sectionSubCardsRef}>
              <div className="dilema-outer-box">
                <div className="dilema-inner-box">
                  <div className="col-md-4">
                    <div className="dile-box">
                      <div
                        className="dile-box-title"
                        dangerouslySetInnerHTML={{
                          __html: HeatContent?.dilemma_heat_map,
                        }}
                      />

                      <div className="dile-box-li" ref={listRef} >
                        <ul>
                          {DilemmaTop.map((item, i) => {
                            const fireCount = 3 - i;

                            return (
                              <li key={i}  
                              
data-bs-toggle="tooltip" data-bs-placement="top"
 data-bs-custom-class="custom-tooltip"
  data-bs-title={item.category_name}
                              >
                                  {/* <span className="dilema-Question-hover">You stay focused on goals, prioritizing outcomes over emotions or distractions</span> */}
                                <span>{item.category_name}</span>

                                <span className="img-for-dilema-res">
                                  <img
                                    src={`${IMG_URL}/d0/${item.icon}`}
                                    alt=""
                                  />
                                </span>

                                <div>
                                  {[...Array(fireCount)].map((_, index) => (
                                    <img key={index} src={fire} alt="" />
                                  ))}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>

                      <div className="dile-box-bottom" dangerouslySetInnerHTML={{__html:HeatContent?.dilemma_heat_map_bottom}} />

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="dile-box">
                      <div
                        className="dile-box-title"
                        dangerouslySetInnerHTML={{
                          __html: HeatContent?.instinct_speed_profile,
                        }}
                      />
                      <div className="dile-box-li dile-box-li-2box">
                        <ul>
                          {DilemmaTop.map((item, i) => {
                            let label = "";
                            let image_link = "";

                            if (i === 0)
                            { 
                              label = "Fastest decision:"; 
                              image_link = `${IMG_URL}/d0/${HeatContent.fastest_icon_image}`;
                            }
                            else if (i === 1)
                            { 
                              label = "Average decision:"; 
                              image_link = `${IMG_URL}/d0/${HeatContent.average_icon_image}`;
                            }
                            else if (i === 2)
                            { 
                              label = "Slowest decision:"; 
                              image_link = `${IMG_URL}/d0/${HeatContent.slowest_icon_image}`;
                            }

                            return (
                              <li key={i}>
                                <div>
                                  <img src={ `${image_link}`} alt="" />
                                </div>
                                <span>
                                  {label} {item?.time_taken}s
                                </span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>

                      <div className="dile-box-bottom" dangerouslySetInnerHTML={{__html:HeatContent?.instinct_speed_profile_bottom}} />

                    </div>

                  </div>
                  <div className="col-md-4">
                    <div className="dile-box barchart-div">
                      <div
                        className="dile-box-title"
                        dangerouslySetInnerHTML={{
                          __html: HeatContent?.decision_finger_print,
                        }}
                      />
                      <div className="diema-barchart-call lock-class-added">
                        <DilemaBarGraph graph_data={GraphData} blur={false} />
                      </div>

                      <div
                      className="dile-box-bottom bar-graohl"
                      dangerouslySetInnerHTML={{
                        __html: HeatContent?.decision_fingerprint_bottom,
                      }}
                    />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row dilema-quiz-outer">
            <div className="col-md-12">
              {AnaysisData?.length > 0 && (
                <div className="dilema-quiz-speed-card" ref={sectionQuizRef}>
                  {HeatContent?.heat_scenario_content && (
                    <div className="row dilema-quiz-speedochart">
                      <div className="col-md-12">
                        <div className="dilema-speed-meter-cover">
                          <div className="dilema-speed-left">
                            {/* <div className="speedomte">
                              <Speedometer2 OverallData={OverallData} />
                            </div> */}

                            <div
                              className="dilema-quiz-speedochart-tile common-h2"
                              dangerouslySetInnerHTML={{
                                __html: HeatContent?.heat_scenario_content,
                              }}
                            />

                            <div className="speedmter-button">
                                
                                <p
                                  dangerouslySetInnerHTML={{ __html: formattedMeasuredText }}
                                />
                              <a>
                                <span>
                                  <img src={fire} alt="" />
                                </span>
                                <span>{HeatContent?.heat_button_label}</span>
                              </a>
                            </div>
                          </div>
                          <div className="dilema-speed-right">
                            <div className="speedomte">
                              <Speedometer2 OverallData={OverallData} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row dilema-quiz-row">
                    {AnaysisData.map((item, i) => (
                      <div className="col-md-3" key={i}>
                        <div className="dilema-quiz-card">
                          <div className="dilema-quiz-cart-title">
                            <span>
                              <img
                                src={`${IMG_URL}/d0/${item?.category_icon}`}
                                alt=""
                              />
                            </span>
                            <h6>{item?.action_name}</h6>
                          </div>
                          <div className="dilema-quiz-cart-data">
                            <span></span>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: item?.category_description,
                              }}
                            />
                            <div
                              className="dilemma-card-bg"
                              style={{ backgroundColor: item?.category_color }}
                            >
                              <p>
                                <span>Faster than </span>
                                <span>{item.percent}%</span>
                                <span> of users</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="row dilema-quiz-content-row">
                <div className="col-md-12">
                  <div className="dilema-quiz-content-top">
                    <div
                      className="result-title-main"
                      dangerouslySetInnerHTML={{
                        __html: Dilemma?.result_content,
                      }}
                    />
                    <div className="dilema-quiz-content-top-imgs-text">
                      <img
                        src={`${IMG_URL}/d0/${Dilemma?.badge_image}`}
                        alt=""
                      />
                      <h6>{Dilemma?.name}</h6>
                    </div>
                  </div>
                  <div className="box-content">
                    <h5>Section Menu:</h5>
                    <ol>
                      {DilemmaResult.filter((item) => item.menu_title).map(
                        (item, i) => (
                          <li
                            key={item.id || i}
                            onClick={() => scrollToSection(item.id || i)}
                            style={{ cursor: "pointer" }}
                          >
                            {item.menu_title}
                          </li>
                        ),
                      )}
                    </ol>
                  </div>
                  {DilemmaResult?.length > 0 && (
                    <div className="result-dilemma-inner dilema-quiz-content-row">
                      {(() => {
                        const grouped = [];
                        let buffer = [];
                        const isExtend = (cls) =>
                          cls.split(" ").includes("extend_section");
                        DilemmaResult.forEach((item, i) => {
                          const cls = item.content_type || "";
                          const node = (
                            <div
                              ref={(el) =>
                                (sectionRefs.current[item.id || i] = el)
                              }
                              className={`result-main ${cls}`}
                              key={item.id || i}
                            >
                              {item.title && <h3>{item.title}</h3>}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.content,
                                }}
                              />
                            </div>
                          );
                          if (isExtend(cls)) {
                            buffer.push(node);
                          } else {
                            if (buffer.length > 0) {
                              grouped.push(
                                <div className="extend-common" key={`g-${i}`}>
                                  {buffer}
                                </div>,
                              );
                              buffer = [];
                            }
                            grouped.push(node);
                          }
                        });
                        if (buffer.length > 0)
                          grouped.push(
                            <div className="extend-common" key="g-end">
                              {buffer}
                            </div>,
                          );
                        return grouped;
                      })()}

                      <div className="previous-pasts">
                        <div className="row rest-last-row-btns">
                          <div className="rest-last-btns rest-buttons">
                            <button
                              className="button freereul"
                              onClick={handleEmailPdf}
                              disabled={PdfLoading}
                            >
                              {PdfLoading
                                ? "Preparing..."
                                : Dilemma?.email_btn_label || "Email My Result"}
                              <span>
                                <FontAwesomeIcon
                                  className="icc"
                                  icon={faArrowRight}
                                />
                              </span>
                            </button>
                            <a
                              className="home-slider-sun-box-a"
                              onClick={() => showPastResults(DilemmaSlug)}
                            >
                              <span className="home-slider-sun-box-a-text">
                                Past results
                              </span>
                              <span className="home-slider-sun-box-a-icon">
                                <FontAwesomeIcon
                                  className="icc"
                                  icon={faArrowRight}
                                />
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SharePopup
        isOpen={isSharePopupOpen}
        onClose={() => setIsSharePopupOpen(false)}
        shareUrl={shareUrl}
        shareImg={shareImg}
        shareTitle={shareTitle}
        shareText={shareText}
        TestUrl={`${SITE_URL}/dilemma/${DilemmaSlug}`}
        filename={filename}
      />

      {EmailSuccess && (
        <div className="modal-question dilema-email-success-modal">
          <div className="modal-test">
            <div className="modal-content-test">
              <div
                className="modal-dymic"
                dangerouslySetInnerHTML={{
                  __html: HeatContent?.email_dilemma_message,
                }}
              />
              <button
                className="modal-close-button-test"
                onClick={() => setEmailSuccess(false)}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DilemaQuizResult;
